<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-12">
    <h3 class="cf-title cf-title--3 cf-text-align-left">
      Contact Info
    </h3>

    <cf-text-input
      v-model="contactInfo.fullName"
      type="text"
      label="Full Name"
      name="fullName"
      icon-class="fa-user-circle"
      :validations="{
        full_name: true,
        required: true
      }"
    />

    <cf-text-input
      v-if="emailInputState !== 'hidden'"
      v-model="contactInfo.email"
      type="email"
      label="Email Address"
      name="email"
      :validations="{ required: emailInputState === 'required' }"
      :show-as-optional="emailInputState === 'optional'"
    />

    <transition name="fade-down-only-in">
      <cf-text-input
        v-if="phoneIsRequired || session.smsReceiptOptIn"
        v-model="contactInfo.phoneNumber"
        type="phone"
        label="Phone Number"
        name="phoneNumber"
        :validations="{
          required: true
        }"
      />
    </transition>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import phone from '@/filters/phone';

  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';

  export default {
    name: 'CfContactInformation',

    components: {
      CfTextInput
    },

    inject: {
      $validator: {
        from: '$validator'
      }
    },

    props: {
      emailInputState: {
        type: String,
        default: 'required',
        validator(value) {
          return ['required', 'optional', 'hidden'].includes(value);
        }
      },

      phoneIsRequired: {
        type: Boolean,
        default: false
      },

      modelValue: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        contactInfo: {
          email: null,
          fullName: null,
          phoneNumber: null
        }
      };
    },

    computed: {
      ...mapGetters('session', ['currentUser', 'session'])
    },

    watch: {
      contactInfo: {
        deep: true,
        handler: 'updateContactInfo',
        immediate: true
      },
      'currentUser.accountId': {
        handler: 'signedInHandler',
        immediate: true
      }
    },

    methods: {
      signedInHandler() {
        if (this.currentUser.accountId) {
          this.contactInfo.email = this.currentUser.email;
          this.contactInfo.fullName = this.currentUser.fullName;
          // primarySmsNumber may arrive in raw digits or other formats; the
          // phone field's regex validator requires (XXX) XXX-XXXX, so
          // normalize before assignment to avoid a stuck "format is invalid"
          // error before the mask directive reformats the DOM input.
          this.contactInfo.phoneNumber = phone(this.currentUser.primarySmsNumber);
        }
      },

      updateContactInfo() {
        this.$emit('update:modelValue', {
          ...this.contactInfo,
          fullName: this.contactInfo.fullName ? this.contactInfo.fullName.trim() : this.contactInfo.fullName
        });
      }
    }
  };
</script>
